import { render, staticRenderFns } from "./TableProps.vue?vue&type=template&id=1f7ba58b"
import script from "./TableProps.vue?vue&type=script&lang=js"
export * from "./TableProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports